module.exports = "<footer class=\"footer\">\n    <div class=\"container-fluid\">\n        <nav class=\"pull-left\">\n           \n        </nav>\n        <div class=\"copyright pull-right\">\n            &copy; {{test | date: 'yyyy'}}, made with <i class=\"fa fa-heart heart\"></i> by <a href=\"www.makebetter.co.za\">MakeBetter</a>\n        </div>\n    </div>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/src/app/shared/footer/footer.component.html
// module id = ../../../../../src/app/shared/footer/footer.component.html
// module chunks = 1